import { createContentPropTypes } from '../../helpers/content';

const tableHeader = [
	{ title: 'Payee Name', path: ['name'] },
	{ title: 'Nickname', path: ['display_name'] },
	{ title: 'Sort code', path: ['sort_code'] },
	{ title: 'Account number', path: ['account_number'] },
	{ title: 'Reference', path: ['reference'] },
];
const tableHeaderWithErrorReasonBACS = [
	{ title: 'Payee Name', path: ['name'] },
	{ title: 'Reference', path: ['reference'] },
	{ title: 'Sort code', path: ['sort_code'] },
	{ title: 'Account number', path: ['account_number'] },
	{ title: 'Error Reason', path: ['error_status'] },
];

const tableHeaderWithErrorReasonBACSCredit = [
	{ title: 'Payee Name', path: ['name'] },
	{ title: 'Reference', path: ['reference'] },
	{ title: 'Sort code', path: ['sort_code'] },
	{ title: 'Account number', path: ['account_number'] },
	{ title: 'HMRC Reference', path: ['hmrcReference'] },
	{ title: 'Error Reason', path: ['error_status'] },
];

const tableHeaderWithErrorReasonFPSCHAPS = [
	{ title: 'From Sort Code', path: ['from_sort_code'] },
	{ title: 'From Account Number', path: ['from_account_number'] },
	{ title: 'Payee Name', path: ['name'] },
	{ title: 'Payment Reference', path: ['reference'] },
	{ title: 'Payee Sort Code', path: ['sort_code'] },
	{ title: 'Payee Account Number', path: ['account_number'] },
	{ title: 'Error Reason', path: ['error_status'] },
];
const uploadErrorFileType = {
	subHeader: 'We only import files that are in .txt or .csv format.',
	footer: 'Please use the instructions to help you create the right file format and try again.',
	panelHeader: 'The problem begins in',
	tableHeader,
};
const uploadErrorMaxRecords = {
	subHeader: 'Your file has more than [[limit]] entries.',
	footer: 'Please remove some entries and try again. You can upload any extra entries you need in another file.',
	panelHeader: 'The problem begins in',
	tableHeader,
};
const uploadErrorStructureError = {
	subHeader:
		'Something is wrong with how the entries are saved. For example, there may more than one entry per line or missing commas.',
	footer: 'Use the instructions and example to help you fix any problems in the file and try again.',
	panelHeader: 'The problem begins in',
	tableHeader,
};
const uploadErrorParseError = {
	subHeader:
		'Something is wrong with the format or length of information in the entries. For example, account details that are too long, too short or have unexpected letters or spaces.',
	footer: 'Use the instructions and example to help you fix any problems in the file and try again.',
	panelHeader: 'The problem begins in',
	tableHeader,
};
const serverError = {
	fullFailureTitle:
		"It looks like there may have been a technical problem while adding your payees. Before you try and import them again, check your payee list to see if they've been successfully added.",
	partialSuccessHeaderWithErrorAndDuplicates:
		'payees successfully. We left off any already on your list or with problems in their payment details.',
	partialSuccessHeaderWithError: 'payees successfully. We left off any with problems in their payment details.',
	partialSuccessHeaderWithDuplicates: 'payees successfully. We left off any already on your list.',
	panelHeader: 'Payees with problems',
	panelSubHeader:
		"Payments to these account details won't go through. Please double-check them before trying to import them again.",
	duplicateAndErrorHeader: 'payees. We left off any already on your list or with problems in their payment details.',
	errorHeader: 'payees. We left off any with problems in their payment details.',
	noImports: 'payees. We left off any already on your list.',
	tableHeader,
};

const checkingPayeesServerErrorBACS = {
	subHeader: 'It looks like there may have been a technical problem while adding your payees.',
	panelHeader: 'The problem begins in',
	panelSubHeader:
		"Payments to these account details won't go through. Please double-check them before trying to import them again.",
	noImports: 'payees, but had issues with a few below.',
	tableHeader: tableHeaderWithErrorReasonBACS,
};
const checkingPayeesServerErrorBACSCredit = {
	...checkingPayeesServerErrorBACS,
	tableHeader: tableHeaderWithErrorReasonBACSCredit,
};
const checkingPayeesServerErrorFPSCHAPS = {
	subHeader: 'It looks like there may have been a technical problem while adding your payees.',
	panelHeader: 'The problem begins in',
	panelSubHeader:
		"Payments to these account details won't go through. Please double-check them before trying to import them again.",
	noImports: 'payees, but had issues with a few below.',
	tableHeader: tableHeaderWithErrorReasonFPSCHAPS,
};
const uploadErrorMinRecords = {
	footer: 'Use the instructions and example to help you set up the file and try again.',
};
export default {
	uploadErrorFileType,
	uploadErrorMaxRecords,
	uploadErrorStructureError,
	uploadErrorParseError,
	serverError,
	checkingPayeesServerErrorBACS,
	checkingPayeesServerErrorBACSCredit,
	checkingPayeesServerErrorFPSCHAPS,
	uploadErrorMinRecords,
};

export const contentPropTypes = createContentPropTypes(uploadErrorFileType);
